export { namespace } from './action';
import { Status, ActionType } from './action';

const initialState = {
  status: Status.INITIAL,
  data: []
}

export default function marketReducer(state = initialState, action) {
  
  switch (action.type) {
    case ActionType.SET_MARKETS:
      {
        const { markets } = action.payload;
        return {
          ...state,
          data: [...markets]
        }
      }


    case ActionType.SET_LOAD_STATUS:
      {
        const { status } = action.payload;
        return {
          ...state,
          status
        }
      }

    default:
      return state;
  }
}
